<template>
  <div>
    <v-card v-bind:color='color'>
      <v-card-title primary-title>
        <v-btn flat icon @click.native='hideReply = !hideReply'>
          <v-icon v-if='hideReply'>add</v-icon>
          <v-icon v-else>remove</v-icon>
        </v-btn>
        <div @click='messageClick'>
          <h3 class='body-3'>
            {{messageNode.message}}
          </h3>
          <div class='caption'>
          <v-avatar
          class='teal'
           size='36px'>
            <img v-if='avatarURL !== ""' :src='avatarURL' />
            <span v-else class='white--text headline'>
              {{avatarDefault}}
            </span>
          </v-avatar>
            {{messageNode.user}}
            {{dateFormatter(messageNode.timeStamp)}}
          </div>
        </div>
      </v-card-title>
      <div v-if='hideReply'>
      </div>
      <v-container
      fluid
      style='min-height: 0;'
      grid-list-lg
      v-else-if = 'childDepth < 4'
      >
      <v-layout row wrap>
        <v-flex xs12>
          <v-menu transition='scale-transition'
          v-model='replyForm'
          :close-on-content-click='false'
          :full-width='true'
          :nudge-width='400'
          >
          <v-btn slot='activator' flat small round :bottom='true'>reply</v-btn>

          <v-card>
            <v-form v-model='valid' ref='replyForm' @submit.prevent='addChild'>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-text-field
                  v-model='chatMessage'
                  :rules='chatMessageRules'
                  required>
                </v-text-field>
              </v-flex>
              <v-flex xs4>
                <v-btn
                type='submit'
                :disabled='!valid'>
                Send
              </v-btn>
            </v-flex>
          </v-layout>
        </v-form>
      </v-card>

    </v-menu>
  </v-flex>
  <v-flex xs12
  v-for = '(value, child) in children'
  v-if='value'
  :key = 'child'
  >
  <recursive-chat-node
  :depth='childDepth'
  :chatNodeID = 'child'
  />
</v-flex>
</v-layout>
</v-container>
<div v-else @click='messageClick'>
  See more replies
</div>
</v-card>
</div>
</template>
<script>
import {db, fbTimeStamp, firestore} from '../../firebase/firebase'
import {mapGetters} from 'vuex'
export default {
  name: 'recursive-chat-node',
  data () {
    return {
      hideReply: true,
      replyForm: false,
      chatMessage: '',
      avatarURL: '',
      chatMessageRules: [
        v => !!v || 'Message can not be blank'
      ],
      valid: true
    }
  },
  firebase: function () {
    return {
      messageNode: {
        source: db.ref(('projects/' + this.$route.params.projectid + '/data/community/' + this.chatNodeID)),
        asObject: true,
        readyCallback: function () {
          let storageRef = firestore.ref('/user/' + this.messageNode.uid + '/avatar.png')
          let that = this
          storageRef.getDownloadURL().then(function (url) {
            that.avatarURL = url
          })
        }
      }
    }
  },
  computed: {
    ...mapGetters('user', {
      currentUser: 'currentUser',
      displayName: 'displayName'
    }),
    avatarDefault () {
      return this.messageNode.user.charAt(0)
    },
    color () {
      if ((this.depth % 2) === 0) {
        return 'blue-grey lighten-5'
      } else {
        return 'blue-grey lighten-4'
      }
    },
    children () {
      return this.messageNode.children
    },
    childDepth () {
      return this.depth + 1
    }
  },
  props: ['depth', 'chatNodeID'],
  methods: {
    dateFormatter (date) {
      let fDate = 'Date Error'
      if (date) {
        fDate = new Date(date).toDateString()
      }
      return fDate
    },
    addChild () {
      var v = this.$firebaseRefs.messageNode.parent.push({
        message: this.chatMessage,
        user: this.displayName,
        timeStamp: fbTimeStamp,
        uid: this.currentUser
      })
      this.$firebaseRefs.messageNode.child('children').child(v.key).set('true')
      this.replyForm = false
      this.chatMessage = ''
      this.$refs.replyForm.reset()

      // if at root, add to properties field, else add to parent node
      // add chat node to data/chat using pushid
    },
    delete () {
      // might be a bad idea, hide ifnot author, keep placeholder for children
    },
    edit () {
      // hide button if not author
    },
    messageClick () {
      this.$router.push({path: 'Community', params: {projectid: this.$route.params.projectid}, query: {chatroot: this.chatNodeID}})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/community/RecursiveChatNode.vue